module.exports = __webpack_public_path__ + "img/Cafe.361f9273.svg";